import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import styled from 'react-emotion';
import MapSenate from './Senate';
import Title from '../../Symbols/Title';
import AreaList from '../AreaList';
import { getHasElectionStarted, getRoundLeaders } from '../../Utils/Getters';

const TitleInfo = styled(Title)`
	@media (max-width: 480px) {
		display: none;
	}
`

class MapSenateFull extends React.PureComponent {
	onClick = (id) => {
		this.props.history.push(`/obvod/${id}`);
	}

	getHasNidData(){
		return this.props.districts[0] && !!this.props.leaders[0][`${this.props.districts[0].id}`].party.nid
	}

	render() {
		return (
			<>
				<Title>
						Vybrat region
					{this.props.selectedAreaId &&
					<Link to="/" style={{ 'float': 'right', marginBottom: '10px' }}>Zpět na celkový přehled</Link>}
				</Title>
				<MapSenate
					districts={this.props.districts}
					leaders={getRoundLeaders(this.props.leaders, this.props.roundIndex, this.props.meta)}
					roundIndex={this.props.roundIndex}
					onClick={this.onClick}
					selectedAreaId={this.props.selectedAreaId}
				/>
				{getHasElectionStarted(this.props.meta[0]) && this.getHasNidData() &&
					<TitleInfo>Obvody se zabarvují podle strany, která vítězícího kandidáta navrhla</TitleInfo>
				}
				<AreaList type="obvod" list={this.props.districts} />
			</>
		)
	}
}

MapSenateFull.propTypes = {
	districts: PropTypes.arrayOf(PropTypes.object).isRequired,
	leaders: PropTypes.arrayOf(PropTypes.object).isRequired,
	roundIndex: PropTypes.number.isRequired,
	selectedAreaId: PropTypes.number,
	meta: PropTypes.object
}

export default withRouter(MapSenateFull);
